import React from 'react';
import { AlertCircle } from 'lucide-react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';

interface DeleteStoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  storyTitle: string;
  isDeleting: boolean;
}

const DeleteStoryModal: React.FC<DeleteStoryModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  storyTitle,
  isDeleting
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Eliminar Historia"
      maxWidth="sm"
      showCloseButton={!isDeleting}
    >
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-rose-100 mb-4">
          <AlertCircle className="h-8 w-8 text-rose-600" />
        </div>

        <h3 className="text-lg font-bold text-stone-900 mb-2">
          ¿Estás seguro?
        </h3>

        <p className="text-sm text-stone-600 mb-1">
          Vas a eliminar la historia:
        </p>

        <p className="text-base font-semibold text-stone-900 mb-4">
          "{storyTitle}"
        </p>

        <div className="bg-rose-50 border border-rose-200 rounded-xl p-3 mb-6">
          <p className="text-xs text-rose-700">
            Esta acción no se puede deshacer. Se perderán todas las grabaciones, transcripciones e imágenes.
          </p>
        </div>

        <div className="flex gap-3">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={isDeleting}
            className="flex-1"
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex-1"
          >
            {isDeleting ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteStoryModal;
